// extracted by mini-css-extract-plugin
export default {"printable":"vp_alF2G","page":"vp_qFPOG"};